/**
 * Los números del negocio, para quien es socio.
 *
 * Distinto de la caja del día: trabaja por RANGO y siempre trae el rango
 * anterior de la misma longitud, porque un número solo no dice nada — S/ 12.000
 * es bueno o malo según lo que fue el mes pasado.
 */
import { apiFetch } from "./client";

export interface LineaReporte {
  nombre: string;
  /** Decimal serializado como string. */
  monto: string;
  cantidad: number;
  /** Pacientes atendidos. No es lo mismo que cobros. */
  atenciones: number;
}

export interface Frecuente {
  nombre: string;
  visitas: number;
  monto: string;
}

export interface Comparado {
  actual: string;
  anterior: string;
}

export interface PuntoSerie {
  /** Ya viene formateada por el servidor: "25/09", "sep 26". */
  etiqueta: string;
  desde: string;
  monto: string;
  cobros: number;
  atendidos: number;
}

export interface PorCobrar {
  /** Capturas de Yape/Plin subidas que caja todavía no ha mirado. */
  validacion_monto: string;
  validacion_cantidad: number;
  /** Atenciones cerradas sin ningún cobro registrado. */
  sin_pago_monto: string;
  sin_pago_cantidad: number;
}

export interface ReporteGerencia {
  desde: string;
  hasta: string;
  comparado_desde: string;
  comparado_hasta: string;
  ingresos: Comparado;
  cobros: Comparado;
  /** Lo que deja de media cada cobro. */
  ticket: Comparado;
  serie: PuntoSerie[];
  /** En qué está troceada la serie: "dia" | "semana" | "mes". */
  paso: string;
  por_cobrar: PorCobrar;
  por_metodo: Record<string, string>;
  /** Consultas, Laboratorio, Farmacia: de dónde sale el dinero. */
  por_origen: Record<string, string>;
  por_especialidad: LineaReporte[];
  por_profesional: LineaReporte[];
  agenda: {
    citas: number;
    atendidas: number;
    no_asistio: number;
    canceladas: number;
    /** Atendidas sobre las que llegaron a tener hora sin cancelarse. */
    asistencia: number;
  };
  pacientes: { nuevos: number; recurrentes: number };
  /** Los que más vinieron en el periodo, de más a menos visitas. */
  frecuentes: Frecuente[];
}

export function getGerencia(desde?: string, hasta?: string): Promise<ReporteGerencia> {
  const q = new URLSearchParams();
  if (desde) q.set("desde", desde);
  if (hasta) q.set("hasta", hasta);
  const cola = q.toString();
  return apiFetch<ReporteGerencia>(`/v1/reportes/gerencia${cola ? `?${cola}` : ""}`);
}
